import { Controller } from "@hotwired/stimulus"

// You can use this controller with data-address-bar-url-value="/new/url/value" to update the address bar when this
// controller connects, this is useful to update the address bar when the page is updated from a turbo frame.
//
// You can also use this controller with data-action="address-bar#replace"
// data-address-bar-url-param="/path/for/address-bar?param=value" to update the address bar through stimulus actions.
//
// You can also control it using data-action="other-controller:event->address-bar#replace" and have that controller
// emit the address like so: this.dispatch("event", { detail: { url: { "/path/for/address-bar?param=value" } }).
//
// When event.detail.url and event.params.url are blank this controller will use event.target.href if it exists.
export default class extends Controller {
  static get values() {
    return { url: String }
  }

  connect() {
    if (this.hasUrlValue) {
      this.replace({ detail: { url: this.urlValue } })
      this.element.remove()
    }
  }

  replace(event) {
    const previousAddress = window.location.pathname

    let newAddress

    if (event.detail && event.detail.url !== undefined) {
      newAddress = event.detail.url
    } else if (event.params && event.params.url !== undefined) {
      newAddress = event.params.url
    } else if (event.target.href !== undefined) {
      newAddress = event.target.href
    }

    if (!newAddress) {
      return
    }

    if (previousAddress !== newAddress) {
      history.replaceState({}, "", newAddress)
    }
  }

  appendParams(event) {
    const url = new URL(window.location.href)
    const paramsToAppend = event.params.paramsToAppend

    Object.entries(paramsToAppend).forEach(([key, value]) => {
      url.searchParams.set(key, value)
    })

    window.history.pushState({}, "", url.toString())
  }

  removeParams(event) {
    const url = new URL(window.location.href)
    const paramsToRemove = event.params.paramsToRemove

    paramsToRemove.forEach((param) => url.searchParams.delete(param))

    window.history.pushState({}, "", url.toString())
  }
}
